import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import CommonPage from '@/components/CommonPage';
import CommonPostDetail from '@/components/CommonPostDetail';
import DiscussionAddForm from '@/components/DiscussionAddForm';
import AttachmentAddForm from '@/components/AttachmentAddForm';
import AddEditMenu from '@/components/AddEditMenu';
import EventAddForm from '@/components/EventAddForm';
import UserList from '@/components/UserList';
import ListUsers from '@/components/UserManagement/ListUsers';
import ListQRCodeScan from '@/components/QRCode/ListQRCodeScan';
import ViewQRCodeDetails from '@/components/QRCode/ViewQRCodeDetails';
import AddUser from '@/components/UserManagement/AddUser';
import AddCalendarKey from '@/components/AddCalendarKey';
import ListCalendarKey from '@/components/ListCalendarKey';
import GridQRCodeImages from '@/components/QRCode/GridQRCodeImages';
import GenerateQRCode from '@/components/QRCode/GenerateQRCode';
import LowGPFormList from '@/components/ApprovalForms/LowGPFormList';
import DepositAdjustmentFormList from '@/components/ApprovalForms/DepositAdjustmentFormList';
import LowGPFormSubmission from '@/components/ApprovalForms/LowGPFormSubmission';
import DepositAdjustmentFormSubmission from '@/components/ApprovalForms/DepositAdjustmentFormSubmission';
import StockBuildRequestFormList from '@/components/ApprovalForms/StockBuildRequestFormList';
import StockBuildRequestFormSubmission from '@/components/ApprovalForms/StockBuildRequestFormSubmission';
import FormApprovalReview from '@/components/ApprovalForms/FormApprovalReview';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/user/list',
      name: 'ListUsers',
      component: ListUsers
    },
    {
      path: '/list/qrcodescan',
      name: 'ListQRCodeScan',
      component: ListQRCodeScan
    },
    {
      path: '/view/qrcodedetails/:id',
      name: 'ViewQRCodeDetails',
      component: ViewQRCodeDetails
    },
    {
      path: '/forms/low-gp/list',
      name: 'LowGPFormList',
      component: LowGPFormList
    },
    {
      path: '/forms/low-gp/add',
      name: 'LowGPFormSubmission',
      component: LowGPFormSubmission
    },
    {
      path: '/forms/deposit-adjustment/list',
      name: 'DepositAdjustmentFormList',
      component: DepositAdjustmentFormList
    },
    {
      path: '/forms/deposit-adjustment/add',
      name: 'DepositAdjustmentFormSubmission',
      component: DepositAdjustmentFormSubmission
    },
    {
      path: '/forms/stock-build-request/list',
      name: 'StockBuildRequestFormList',
      component: StockBuildRequestFormList
    },
    {
      path: '/forms/stock-build-request/add',
      name: 'StockBuildRequestFormSubmission',
      component: StockBuildRequestFormSubmission
    },
    {
      path: '/forms/stock-build-request/edit/:id',
      name: 'StockBuildRequestFormEdit',
      component: StockBuildRequestFormSubmission
    },
    {
      path: '/forms/approval/review',
      name: 'FormApprovalReview',
      component: FormApprovalReview
    },
    {
      path: '/:type',
      name: 'CommonPage',
      component: CommonPage
    },
    {
      path: '/:type/view',
      name: 'CommonPostDetail',
      component: CommonPostDetail
    },
    {
      path: '/:type/add_post',
      name: 'DiscussionAddForm',
      component: DiscussionAddForm
    },
    {
      path: '/:type/edit_post/:id',
      name: 'DiscussionEditForm',
      component: DiscussionAddForm
    },
    {
      path: '/:type/add_document',
      name: 'AttachmentAddForm',
      component: AttachmentAddForm
    },
    {
      path: '/:type/edit_document/:id',
      name: 'AttachmentEditForm',
      component: AttachmentAddForm
    },
    {
      path: '/:type/add_date',
      name: 'EventAddForm',
      component: EventAddForm
    },
    {
      path: '/:type/edit_date/:id',
      name: 'EventEditForm',
      component: EventAddForm
    },
    {
      path: '/menu/add-edit-menu',
      name: 'AddEditMenu',
      component: AddEditMenu
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/user/add',
      name: 'AddUser',
      component: AddUser
    },
    {
      path: '/updateuser/:id',
      name: 'UpdateUser',
      component: AddUser
    },
    {
      path: '/key/list',
      name: 'ListCalendarKey',
      component: ListCalendarKey
    },
    {
      path: '/key/add',
      name: 'AddCalendarKey',
      component: AddCalendarKey
    },
    {
      path: '/key/edit/:id',
      name: 'EditCalendarKey',
      component: AddCalendarKey
    },
    {
      path: '/qrcode/grid/:session',
      name: 'GridQRCodeImages',
      component: GridQRCodeImages
    },
    {
      path: '/qr-code/generate',
      name: 'GenerateQRCode',
      component: GenerateQRCode
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js